export const SESSIONS_REFETCH_INTERVAL = 30 * 1000; // 30 seconds
// Moved to `@heidi/session/contracts` with the D1 family — it's baked into
// the v2 infinite-sessions cache key, so it's part of the key contract.
export { SESSIONS_PAGE_SIZE } from '@heidi/session/contracts';

// React Query key for the flag-gated session list (see useQuerySessionsList).
// Re-exported from `@heidi/session/contracts`, where the key contracts now
// live (OpenSpec `monorepo-session-data-core` task C1); this line keeps the
// existing importers resolving until task Z1's codemod re-points them.
export { GET_SESSIONS_LIST } from '@heidi/session/contracts';

/**
 * Retry configuration for session list queries.
 * Uses exponential backoff to handle transient failures
 * (e.g. stale auth tokens after desktop app update, network warmup).
 */
export const SESSIONS_QUERY_RETRY = 3;
export const SESSIONS_QUERY_RETRY_DELAY = (attemptIndex: number) =>
  Math.min(1000 * 2 ** attemptIndex, 10_000);

// Single-declared on `@heidi/session/contracts`. Re-exported so logout and the
// remaining app readers keep one string.
export {
  CACHED_VISIBLE_SCOPES_STORAGE_KEY,
  DESKTOP_SESSIONS_LIST_CACHE_KEY,
  SESSION_LIST_SCOPE_STORAGE_KEY,
} from '@heidi/session/contracts';
